import { DeviceStatus, DeviceStatusCause } from 'types/device.enum';
import { shouldMarkAsDelayed } from 'utils/Device/Xtend/should-mark-as-delayed';

type Input = {
  status: DeviceStatus,
  statusCause: DeviceStatusCause,
  lastStatusDate: number,
  lastSampleDate: number
};

/**
 * Frontend workaround for Xtend Trough and Xtend Heated Trough devices that incorrectly report ONLINE
 * status despite not transmitting data recently. This function corrects the status to DELAYED when
 * no data has been received within the expected transmission window (12 hours).
 *
 * Ideally, this should be fixed in FRED rather than handled on the frontend.
 *
 * Related tickets:
 * - https://farmbot.atlassian.net/browse/FMBT-8657
 * - https://farmbot.atlassian.net/browse/FMBT-8592
 * - https://farmbot.atlassian.net/browse/FMBT-9156
 *
 * When this is not needed anymore, consider also cleaning up the implementation in
 * src/store/modules/devices/utils/patch-device-status.ts
 */
export const patchBridgeDeviceStatus = ({
  status,
  statusCause,
  lastStatusDate,
  lastSampleDate
}: Input) => {
  if (status === DeviceStatus.UNKNOWN) {
    const latestDate = lastSampleDate > lastStatusDate
      ? lastSampleDate
      : lastStatusDate;

    if (shouldMarkAsDelayed(latestDate)) {
      status = DeviceStatus.DELAYED;
      statusCause = DeviceStatusCause.TRANSMISSION_MISSED;
    } else {
      status = DeviceStatus.ONLINE;
      statusCause = DeviceStatusCause.PACKET_RECEIVED;
    }

    return {
      status,
      statusCause,
      lastStatusDate: latestDate
    };
  }

  return {
    status,
    statusCause,
    lastStatusDate
  };
};
